// Currency Handler - Optimized
function cartIntervals() {
  const cartInterval = setInterval(function() {
    const symbol = window.shopifyCurrencySymbol;
    const currency = window.shopifyCurrency;

    const cartPrices = document.querySelectorAll('.rebuy-cart__flyout-item-price span.rebuy-money span:not(.sr-only)');
    if(cartPrices.length > 0 && currency == 'EUR') {
      cartPrices.forEach((_price) => {
        if(_price.textContent.includes('$')) {
          _price.innerText = _price.textContent.replace('$', symbol);
        }
      });
    }
  }, 100);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cartIntervals);
} else {
  cartIntervals();
}
